import React from 'react';
import _ from 'lodash';
import { OverlayTrigger, Tooltip as TooltipBootstrap } from 'react-bootstrap';
import DDadosBase, { LabeledInput } from '@common/components/ddados/ddados.base';
import Field from '@common/components/validation/field.validation';
import FocusHelper from '@common/helpers/focus.helper';
import autoBind from 'react-autobind';

class BaseComponent extends DDadosBase {
  constructor(props) {
    super(props);

    this.tooltip = props.Tooltip || props.Label;

    autoBind(this);
  }

  getViewValue(value) {
    const { valueField, textField } = this.props;

    let valuedItem = this.optionsArray.find((item) => item[valueField || 'Valor'] === value);

    if (valuedItem) {
      return valuedItem[textField || 'Texto'];
    } else return value;
  }

  get optionsArray() {
    const { valueField, textField, itens, SemOpcaoSelecione, isView, isColumnEdit, Obrigatorio } = this.props;
    const removeSelecione = SemOpcaoSelecione ?? (isColumnEdit && Obrigatorio);

    let options = [];

    if (!removeSelecione) {
      options = [
        {
          [valueField || 'Valor']: '',
          [textField || 'Texto']: isView ? '' : 'Selecione',
        },
      ];
    }

    options.push(...(itens || []));

    return options;
  }

  formatOptionText(textValue) {
    const { displaySizeLimit } = this.props;
    const textLength = textValue?.length;

    if (displaySizeLimit && textLength > displaySizeLimit) return `${textValue.substring(0, displaySizeLimit)}...`;

    return textValue;
  }

  ajuda(value) {
    const { itens, valueField, textField, displayHintAjuda } = this.props;

    if (!displayHintAjuda) return null;

    let findAjuda = itens?.find((item) => item[valueField || 'Valor'] == value);

    return findAjuda ? findAjuda[textField || 'Texto'] : '';
  }

  componentDidMount() {
    this.setFocus();
  }

  setFocus() {
    const { name, setFocus } = this.props;
    if (setFocus) FocusHelper.focus(name);
  }

  componentDidUpdate(prevProps) {
    if (prevProps.name !== this.props.name) {
      const { Tooltip, Label } = this.props;

      this.tooltip = Tooltip || Label;
    }
  }

  getOpcaoValida(valueCheck) {
    const {
      valueField
    } = this.props;

    let opcao = undefined;

    this.optionsArray.forEach(item => {
      if(!opcao) {
        const valueItem = item[valueField || 'Valor'];
        const isNumberItem = typeof(valueItem) == 'number';
        const isBoolValue = _.isBoolean(valueCheck) || ((`${valueCheck}`)?.toLowerCase() == 'true' || (`${valueCheck}`)?.toLowerCase() == 'false');
        const isBoolItem = _.isBoolean(valueItem) || ((`${valueItem}`)?.toLowerCase() == 'true' || (`${valueItem}`)?.toLowerCase() == 'false');

        if(isBoolItem && isBoolValue && (`${valueCheck}` == `${valueItem}`)) {
          let newItem = _.cloneDeep(item);

          newItem[valueField || 'Valor'] = `${valueCheck}` == 'true';
          
          opcao = item;
        }

        if(isNumberItem) {
          if((parseInt(valueCheck) == valueItem)) {
            let newItem = _.cloneDeep(item);
            
            newItem[valueField || 'Valor'] = valueItem;

            opcao = newItem;
          }
        }

        if(valueCheck == valueItem)
          opcao = item;
      }
    });

    return opcao;
  }

  renderComponent() {
    const { props } = this;

    const {
      Label,
      Tooltip,
      Obrigatorio,
      Desabilitado,
      valueField,
      textField,
      name,
      PlacementTooltip,
      onKeyDown,
      placeHolder,
      utilizaTooltipOpcao,
    } = props;

    return (
      <Field {...props}>
        {({ value, hasError, onChangeAsync, onBlur }) => {
          return (
            <LabeledInput Ajuda={this.ajuda(value)} {...props}>
              <OverlayTrigger
                key={`top-${name}`}
                placement={PlacementTooltip || 'top'}
                overlay={
                  this.tooltip ? (
                    <TooltipBootstrap id={`tooltip-${name}`}>
                      <div className="fontTooltip">{this.tooltip}</div>
                    </TooltipBootstrap>
                  ) : (
                    <div />
                  )
                }
              >
                <div>
                  <select
                    name={name}
                    className={`form-control ${hasError ? 'form-invalid' : ''}`}
                    onChange={(e) => {
                      const valueCheck = e?.target?.value;

                      let opcao = this.getOpcaoValida(valueCheck) ?? undefined;
                      
                      onChangeAsync(opcao[valueField || 'Valor']);

                      if(utilizaTooltipOpcao) {                  
                        if(opcao)
                          this.tooltip = opcao[textField || 'Texto'];
                        else
                          this.tooltip = Tooltip || Label;
                      } else {
                        this.tooltip = Tooltip || Label;
                      }
                    }}
                    onBlur={props.onBlur ? onBlur : undefined}
                    value={value !== '' && value !== undefined ? value : ''}
                    disabled={Desabilitado}
                    required={Obrigatorio}
                    onKeyDown={(event) => {
                      if (onKeyDown) {
                        event.preventDefault();
                        onKeyDown(event);
                      }
                    }}
                  >
                    {this.optionsArray.map((item, i) => {
                      return (
                        <>
                          {placeHolder && (
                            <option value={placeHolder} disabled selected hidden>
                              {placeHolder}
                            </option>
                          )}
                          <option
                            key={i}
                            value={
                              item[valueField || 'Valor'] !== '' && item[valueField || 'Valor'] !== undefined
                                ? item[valueField || 'Valor']
                                : ''
                            }
                          >
                            {this.formatOptionText(item[textField || 'Texto'])}
                          </option>
                        </>
                      );
                    })}
                  </select>
                </div>
              </OverlayTrigger>
            </LabeledInput>
          );
        }}
      </Field>
    );
  }

  renderView() {
    return (
      <Field {...this.props}>
        {(field) => {
          return (
            <LabeledInput {...this.props} Obrigatorio={false}>
              <span>
                <label className="form-control" readOnly>
                  {this.getViewValue(field.value)}
                </label>
              </span>
            </LabeledInput>
          );
        }}
      </Field>
    );
  }

  renderHeader() {
    return (
      <div>
        <Field {...this.props}>
          {(field) => {
            return (
              <label style={{ fontWeight: 'bold' }}>
                {this.props.Label}
                <label>{this.getViewValue(field.value)}</label>
              </label>
            );
          }}
        </Field>
      </div>
    );
  }
}

export default BaseComponent;
